import * as React from 'react';
import { formatUSDWithCents } from '../Utils/Currency';

type EarningPayment = {
  id: number;
  postedAt: string;
  amountCents: number;
  projectName: string;
  projectType: 'ProjectRequest' | 'Hourly::Payment';
  customerName: string;
}

type Props = {
  totalEarningsCents: number;
  payments: EarningPayment[];
}

function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

function projectTypeLabel(type: string): string {
  switch (type) {
    case 'ProjectRequest':
      return 'Project';
    case 'Hourly::Payment':
      return 'Hourly';
    default:
      return '';
  }
}

const Earnings = (props: Props) => {
  const { totalEarningsCents, payments } = props;

  const TotalEarningsCard = () => (
    <div className="card rounded-4 bg-accent border-0 mb-4">
      <div className="card-body p-4 text-center">
        <div className="fs-sm text-secondary mb-1">Total Lifetime Earnings</div>
        <div className="display-5 fw-bold text-dark">{formatUSDWithCents(totalEarningsCents)}</div>
      </div>
    </div>
  );

  const PaymentRow = ({ payment }: { payment: EarningPayment }) => (
    <div className="card rounded-4 mb-2">
      <div className="card-body p-3">
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <div className="fw-semibold">{payment.projectName}</div>
            <div className="fs-sm text-secondary">
              {projectTypeLabel(payment.projectType)} with {payment.customerName}
            </div>
          </div>
          <div className="text-end">
            <div className="fw-semibold text-success">
              {formatUSDWithCents(payment.amountCents)}
            </div>
            <div className="fs-xs text-secondary">
              {formatDate(payment.postedAt)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const EmptyState = () => (
    <div className="my-5 text-center">
      <div className="fs-lg text-dark mt-2">
        No earnings yet. Claim your first request to get started!
      </div>
      <a href="/copilot" className="btn btn-primary mt-3">
        View open requests
      </a>
    </div>
  );

  return (
    <div className="mt-3">
      <TotalEarningsCard />

      {payments.length === 0 ? (
        <EmptyState />
      ) : (
        <div>
          <h5 className="mb-3">Payment History</h5>
          {payments.map((payment) => (
            <PaymentRow key={payment.id} payment={payment} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Earnings;
